export default "__VITE_ASSET__CJP2hAe7__"